import { useState } from 'react';

const useModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

  const showModal = (message, type = 'info', title = '') => {
    setModalState({
      isOpen: true,
      message,
      type,
      title
    });
  };

  const hideModal = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  const showSuccess = (message, title) => showModal(message, 'success', title);
  const showError = (message, title) => showModal(message, 'error', title);
  const showWarning = (message, title) => showModal(message, 'warning', title);
  const showInfo = (message, title) => showModal(message, 'info', title);

  return {
    modalState,
    showModal,
    hideModal,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};

export default useModal;